/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient, HttpContext} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IApiCall} from '../../model/IApiCall';
import {AppLoggerService} from '../logger/app-logger.service';
import {ErrorMessage} from '../../constants/app.error.constant';
import {IResponseType} from '../../model/IAppRespType';
import {Observable} from 'rxjs';
import {SKIP_LOADER} from '../../model/app.api.skip-loader';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppBaseApiService {
  constructor(
    private readonly logger: AppLoggerService,
    private readonly httpClient: HttpClient
  ) {}

  apiCall<T>({
    url,
    body,
    headers,
    httpParam,
    requestType = 'GET',
    responseType = 'json' as IResponseType,
    skipLoader = false,
  }: IApiCall<any>) {
    if (!url) {
      this.logger.error(ErrorMessage.URL_REQUIRED, url);
    }
    if (!requestType) {
      this.logger.error(ErrorMessage.REQUEST_TYPE_REQUIRED, requestType);
    }
    url = `${environment.baseApiUrl}${url}`;
    return this.httpClient.request<T>(requestType, `${url}`, {
      body,
      headers,
      params: httpParam,
      context: skipLoader ? new HttpContext().set(SKIP_LOADER, true) : undefined,
    });
  }
}
